
import { APP_SETTINGS, SpinnerService, ToastConfigService, UtilityService } from '@services';
import { filter } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaypalService } from './paypal.service';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare let paypal: any;

@Component({
    selector: 'app-paypal-login',
    templateUrl: './paypal-login.component.html',
    styleUrls: ['./paypal-login.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgFor,
    ],
})
export class PaypalLoginComponent implements OnInit {


  private PAYPAL_SCRIPT_URL = 'https://www.paypal.com/sdk/js';
  public screenWidth: number;

  public username;
  public password;
  public errorMessage = '';
  public showPaypalButton = false;

  // Paypal Related Variables
  public isPaypalScriptAdded = false;
  public paypalLoad = true;

  public makeName: 'MINI' | 'ROLLSROYCE' | 'BMW';
  public tisSubscriptions: any;
  public selectedSubscriptionObj;

  private clientId = {
    production: {
      default: 'AWwLmfPUiC2_L6nQigQbZiHZmHcOR6ll615RtjIjPO87Ir9Mqd29jVqYouxB8mQCLYPK4ofY8hwlOYjB',
      rollsRoyce: 'AfIc1U8McJC9OykMagPWlVv6mv4GOSK-L-AbJoN4UBy36KqNm85eJ2ulSw_dQXrzaJq-Dfn30Lm88-0S'
    },
    sandbox: {
      default: 'Ads2_Z-BFEcvkz5HubXqeOwZw1sWspQSt0HP3PxGM8nJW0gfosio6H3GjtYwVLA_-bPFJc84noAZ_U9C',
      rollsRoyce: 'Ads2_Z-BFEcvkz5HubXqeOwZw1sWspQSt0HP3PxGM8nJW0gfosio6H3GjtYwVLA_-bPFJc84noAZ_U9C',
    }
  }

  private selectedClientId: string;

  private paypalConfig = {
    style: {
      layout: 'vertical',
      color: 'gold',
      shape: 'rect',
      label: 'paypal'
    },
    createOrder: (data, actions) => {
      return actions.order.create({
        purchase_units: [{
          amount: {
            value: this.selectedSubscriptionObj.price,
            currency_code: 'USD'
          },
          description: this.selectedSubscriptionObj.description,
          custom_id: this.username + "|" + this.selectedSubscriptionObj.subscriptionId
        }]
      });
    },
    onApprove: (data, actions) => {
      return actions.order.capture().then((details) => {
        this.processPayment(data, details);
      });
    },
    onCancel: (data) => {
      window.alert('Payment flow failed. Please try again.');
    },
    onError: (err) => {
      console.error('PayPal error:', err);
      window.alert('An error occurred during payment processing.');
    }
  };

  constructor(
    private utilityService: UtilityService,
    private paypalService: PaypalService,
    private spinnerService: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastConfigService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  private processPayment(data, orderDetails): void {
    const purchaseUnit = orderDetails.purchase_units[0];
    const customValues = purchaseUnit.custom_id.split("|");

    const paymentObject = {
      "subscriptionID": customValues[1],
      "userID": customValues[0],
      "orderNumber": data.orderID,
      "payerID": data.payerID,
      "paymentNumber": orderDetails.id,
      "email": orderDetails.payer.email_address,
      "firstName": orderDetails.payer.name.given_name,
      "lastName": orderDetails.payer.name.surname,
      "middleName": "", 
      "countryCode": orderDetails.payer.address?.country_code || "",
      "status": orderDetails.status,
      "paymentMode": "instant",
      "createDate": orderDetails.create_time,
      "updateDate": orderDetails.update_time,
      "transactionID": purchaseUnit.payments.captures[0].id
    };

    this.spinnerService.show('bmwSpinner');
    this.paypalService.addPaypalTransaction(paymentObject)
      .subscribe(updateResponse => {
        this.spinnerService.hide('bmwSpinner');
        if (updateResponse) {
          this.toastService.popToast('The payment has been processed successfully and the account has been activated. Please login to access the site');
        }
        setTimeout(() => {
          this.router.navigateByUrl('login');
        }, 5000);
      },
        error => {
		  this.toastService.popToast('The payment process failed. Please contact TIS support.');
          this.errorMessage = error.error.message;
          this.spinnerService.hide('bmwSpinner');
        });
  }

  ngOnInit() {
    this.makeName = APP_SETTINGS.isMINI === 'true' ? 'MINI' : APP_SETTINGS.isRollsRoyce === 'true' ? 'ROLLSROYCE' : 'BMW';

    this.paypalService.getAllSubcriptions(this.makeName).subscribe(data => {
      this.tisSubscriptions = data;
      this.errorMessage = '';
      this.selectedSubscriptionObj = this.tisSubscriptions[0];
    },
      error => {
        this.errorMessage = error.error.message;
      });

    this.route.queryParams.pipe(
      filter(params => params.user))
      .subscribe(params => {
        this.username = params.user;
      });

    if (this.username == null || !(this.username)) {
      alert("User id is not present to proceed with the subscription. Redirecting to login page");
      setTimeout(() => {
        this.router.navigateByUrl('login');
      }, 1000);
    }

    this.paypalService.hasActiveSubcription(this.username).subscribe(data => {
      if (data && data.response.toLowerCase() === "yes") {
        alert("There is already an active subscription attached with your id " + this.username + " . Please contact support.");
        setTimeout(() => {
          this.router.navigateByUrl('login');
        }, 1000);
      }
    },
      error => {
        this.errorMessage = error.error.message;
      });
  }

  ngAfterViewChecked(): void {
    if (!this.isPaypalScriptAdded && this.paypalLoad) {
      this.paypalService.getPaypalEnvironment().subscribe(data => {
        if (data) {
          const paypalEnvironment: 'sandbox' | 'production' = data.mode;

          if (this.makeName === 'ROLLSROYCE') {
            this.selectedClientId = this.clientId[paypalEnvironment].rollsRoyce
          } else {
            this.selectedClientId = this.clientId[paypalEnvironment].default
          }

          this.addPaypalScript().then(() => {
            this.paypalConfig['funding'] = {
              allowed: [paypal.FUNDING.ELV],
              disallowed: [paypal.FUNDING.CREDIT, paypal.FUNDING.CARD]
            };

            paypal.Buttons(this.paypalConfig).render('#paypal-checkout-btn');
            this.paypalLoad = false;
          });
        }
      },
        error => {
          this.errorMessage = error.error.message;
        });

    }
  }

  /* Paypal script has to be loaded after the page has been initialized*/
  addPaypalScript() {
    this.isPaypalScriptAdded = true;
    return new Promise((resolve, reject) => {
      let scripttagElement = document.createElement('script');

      const params = new URLSearchParams({
        'client-id': this.selectedClientId,
        'currency': 'USD',
        'intent': 'capture'
      });

      scripttagElement.src = `${this.PAYPAL_SCRIPT_URL}?${params.toString()}`;

      scripttagElement.onload = resolve;
      scripttagElement.onerror = reject;
      document.body.appendChild(scripttagElement);
    })
  }

  onChangeSubscription(subObject) {
    this.selectedSubscriptionObj = subObject;
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}